import { observer } from "mobx-react-lite";
import * as React from "react";
import { MdmTable, MdmTableSystemTools } from "src/components/MdmTable";
import { PageLayout } from "src/components/PageLayout";
import { RtSearch } from "src/components/ReactiveTable/components/RtSearch";
import { ToolBox2 } from "src/components/ToolBox2";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { classifiersPageStore as pageStore } from "./ClassifiersPageStore";

export const ClassifiersPage: React.FC = observer(() => {
  const { tableStore, columns } = pageStore;

  return (
    <PageLayout title="Классификаторы">
      <ToolBox2
        paddingMode="page"
        mainTool={<RtSearch store={tableStore} />}
        extraTools={<MdmTableSystemTools store={tableStore} />}
      >
        <MdmTable
          store={tableStore}
          columns={columns}
          resizableColumns
          rowClick={{
            type: "link",
            builder: (row) => makeUrl(PageUrl.classes, { id: row.id }),
          }}
        />
      </ToolBox2>
    </PageLayout>
  );
});
